var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createApi, fetchBaseQuery, } from "@reduxjs/toolkit/query/react";
import { ETCRM_API_URL, CLIENT_ID, CLIENT_SECRET } from "@/utils/const";
// import { RootState } from "..";
import { logger } from "@/utils/loggerService";
import { clearToken, setToken } from "@/store/authSlice";
import * as jose from "jose";
import qs from "qs";
import { Mutex } from "async-mutex";
import { decodeDeepOptimized } from "@/utils/htmlDecode";
//{ table, sorted, where }
var filterSearchUrl = function (url, params) {
    var filters = (params === null || params === void 0 ? void 0 : params.where) || [];
    var sortParams = (params === null || params === void 0 ? void 0 : params.sorted) || [];
    var page = params === null || params === void 0 ? void 0 : params.page;
    var pageSize = params === null || params === void 0 ? void 0 : params.pageSize;
    var count_only = (params === null || params === void 0 ? void 0 : params.count_only) || false;
    var count = (params === null || params === void 0 ? void 0 : params.count) || false;
    //const skip = page * pageSize;
    //const take = pageSize >= 0 ? pageSize : undefined;
    var skip;
    var take;
    if (page !== undefined && pageSize !== undefined) {
        skip = page * pageSize;
        take = pageSize;
    }
    var searchParams = qs.stringify({
        where: filters,
        sorted: sortParams,
        skip: skip,
        take: take,
        count_only: count_only,
        count: count,
    });
    var operator = (url === null || url === void 0 ? void 0 : url.indexOf("?")) >= 0 ? "&" : "?";
    return "".concat(url).concat(operator).concat(searchParams);
};
/**
 * Requête de base
 */
var baseQuery = fetchBaseQuery({
    baseUrl: ETCRM_API_URL,
    prepareHeaders: function (headers, _a) {
        var getState = _a.getState;
        var state = getState();
        var token = state.auth.token;
        logger.debug("[baseQuery/prepareHeaders] - Modification du 'Content-Type' par 'application/json'");
        headers.set("Content-Type", "application/json");
        if (token) {
            logger.debug("[baseQuery/prepareHeaders] - Rattachement du token d'identification aux requ\u00EAtes", token);
            headers.set("Authorization", "Bearer ".concat(token));
            return headers;
        }
    },
    validateStatus: function (response, result) {
        return response.status >= 200 &&
            response.status <= 299 &&
            ((result === null || result === void 0 ? void 0 : result.access_token) || (result === null || result === void 0 ? void 0 : result.status) === "success");
    },
});
// Mutex
var mutex = new Mutex();
/**
 * Create Base query with reauth
 *
 * @param baseQuery
 * @returns
 */
export var createBaseQueryWithReauth = function (baseQuery) {
    /**
     * Base Query with refresh token
     * // https://redux-toolkit.js.org/rtk-query/usage/customizing-queries#preventing-multiple-unauthorized-errors
     * @param args
     * @param api
     * @param extraOptions
     * @returns
     */
    return function (args, api, extraOptions) { return __awaiter(void 0, void 0, void 0, function () {
        var result, release, state, refreshResult, authToken, tokenInfo, result_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: 
                // wait for mutex
                return [4 /*yield*/, mutex.waitForUnlock()];
                case 1:
                    // wait for mutex
                    _a.sent();
                    return [4 /*yield*/, baseQuery(args, api, extraOptions)];
                case 2:
                    result = _a.sent();
                    if (!(result.error && result.error.status === 401)) return [3 /*break*/, 15];
                    if (!!mutex.isLocked()) return [3 /*break*/, 11];
                    return [4 /*yield*/, mutex.acquire()];
                case 3:
                    release = _a.sent();
                    _a.label = 4;
                case 4:
                    _a.trys.push([4, , 9, 10]);
                    state = api.getState();
                    return [4 /*yield*/, baseQuery({
                            url: "".concat(ETCRM_API_URL, "/access_token"),
                            method: "POST",
                            body: {
                                client_id: CLIENT_ID,
                                client_secret: CLIENT_SECRET,
                                grant_type: "refresh_token",
                                refresh_token: state.auth.refreshToken,
                            },
                        }, api, extraOptions)];
                case 5:
                    refreshResult = _a.sent();
                    if (!refreshResult.data) return [3 /*break*/, 7];
                    authToken = refreshResult.data;
                    tokenInfo = jose.decodeJwt(authToken.access_token);
                    api.dispatch(setToken({
                        //currentUser: tokenInfo.sub,
                        token: authToken.access_token,
                        refreshToken: authToken.refresh_token,
                        token_iat: tokenInfo.iat,
                        token_exp: tokenInfo.exp,
                    }));
                    return [4 /*yield*/, baseQuery(args, api, extraOptions)];
                case 6:
                    // retry the initial query
                    result = _a.sent();
                    return [3 /*break*/, 8];
                case 7:
                    // Logout
                    api.dispatch(clearToken());
                    _a.label = 8;
                case 8: return [3 /*break*/, 10];
                case 9:
                    release();
                    return [7 /*endfinally*/];
                case 10: return [3 /*break*/, 14];
                case 11: 
                // wait until the mutex is available
                return [4 /*yield*/, mutex.waitForUnlock()];
                case 12:
                    // wait until the mutex is available
                    _a.sent();
                    return [4 /*yield*/, baseQuery(args, api, extraOptions)];
                case 13:
                    result = _a.sent();
                    _a.label = 14;
                case 14: return [3 /*break*/, 16];
                case 15:
                    if (result.error &&
                        (result.error.status === "PARSING_ERROR" ||
                            result.error.status === "FETCH_ERROR")) {
                        result_1 = baseQuery(args, api, extraOptions);
                        return [2 /*return*/, result_1];
                    }
                    _a.label = 16;
                case 16: return [2 /*return*/, result];
            }
        });
    }); };
};
/**
 * Slice pour la gestion des appels Api
 */
export var apiSlice = createApi({
    reducerPath: "api",
    baseQuery: createBaseQueryWithReauth(baseQuery),
    tagTypes: [
        "System",
        "UserSession",
        "Subpanel",
        "Records",
        "Admin",
        "Reminders",
        "UserDashlets",
        "Alerts",
        "Favorites",
        "AOR_Reports",
        "UpgradeWizard",
        "securityGroups",
    ],
    endpoints: function (builder) { return ({
        loadSystemConfigurations: builder.query({
            query: function () { return "/configuration/system"; },
            providesTags: ["System"],
        }),
        getAccessToken: builder.mutation({
            query: function (_a) {
                var username = _a.username, password = _a.password;
                return ({
                    url: "/access_token",
                    method: "POST",
                    body: {
                        client_id: CLIENT_ID,
                        client_secret: CLIENT_SECRET,
                        grant_type: "password",
                        username: username,
                        password: password,
                    },
                });
            },
            invalidatesTags: ["UserSession", "Records", "Subpanel", "Admin"],
            transformResponse: function (baseQueryReturnValue, meta, arg) {
                var result = baseQueryReturnValue;
                return { status: "success", data: __assign({}, result) };
            },
            transformErrorResponse: function (baseQueryReturnValue, meta, arg) {
                var error = baseQueryReturnValue;
                return { status: "failed", data: __assign({}, error) };
            },
            onCacheEntryAdded: function (arg, _a) {
                var dispatch = _a.dispatch, getCacheEntry = _a.getCacheEntry, cacheDataLoaded = _a.cacheDataLoaded, cacheEntryRemoved = _a.cacheEntryRemoved;
                return __awaiter(void 0, void 0, void 0, function () {
                    var entry, authToken, tokenInfo;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: 
                            /// Sauvegarde automatique des données du modèle dans le cache et calcul des champs
                            return [4 /*yield*/, cacheDataLoaded];
                            case 1:
                                /// Sauvegarde automatique des données du modèle dans le cache et calcul des champs
                                _b.sent();
                                entry = getCacheEntry().data;
                                authToken = entry === null || entry === void 0 ? void 0 : entry.data;
                                tokenInfo = jose.decodeJwt(authToken.access_token);
                                dispatch(setToken({
                                    currentUser: tokenInfo.sub,
                                    token: authToken.access_token,
                                    refreshToken: authToken.refresh_token,
                                    token_iat: tokenInfo.iat,
                                    token_exp: tokenInfo.exp,
                                }));
                                return [4 /*yield*/, cacheEntryRemoved];
                            case 2:
                                _b.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            },
        }),
        getCurrentUser: builder.query({
            query: function () { return "/profile/current"; },
            providesTags: ["UserSession"],
        }),
        saveUserPreferences: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/profile/current/saveViewlistPreferences",
                    method: "POST",
                    body: body,
                });
            },
            invalidatesTags: ["UserSession"],
        }),
        changeCurrentLang: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/changeCurrentLang",
                    method: "POST",
                    body: body,
                });
            },
        }),
        saveWidgetPreferences: builder.mutation({
            query: function (widgets) { return ({
                url: "/widgets",
                method: "POST",
                body: widgets,
            }); },
            invalidatesTags: ["UserSession"],
        }),
        getWidgetsPreferencesUser: builder.query({
            query: function () { return "/widgets"; },
        }),
        getAllMenu: builder.query({
            query: function () { return "/meta/menu"; },
            transformResponse: function (response) {
                return decodeDeepOptimized(response);
            },
        }),
        getModuleFields: builder.query({
            query: function (moduleName) { return "/meta/".concat(moduleName, "/fields"); },
            transformResponse: function (response) {
                return decodeDeepOptimized(response);
            },
        }),
        getModuleFieldDefs: builder.query({
            query: function (moduleName) { return "/meta/".concat(moduleName, "/layouts/listviewdefs"); },
        }),
        getModuleFieldType: builder.query({
            query: function (_a) {
                var moduleName = _a.moduleName, params = _a.params;
                return ({
                    url: "/meta/".concat(moduleName, "/field"),
                    params: params,
                });
            },
        }),
        getModuleFieldsBuilder: builder.query({
            query: function (_a) {
                var params = _a.params;
                return ({
                    url: "/moduleBuilder/modulefields",
                    params: params,
                });
            },
        }),
        getModuleWizardBuilder: builder.query({
            query: function (_a) {
                var params = _a.params;
                return ({
                    url: "/moduleBuilder/wizard",
                    params: params,
                });
            },
        }),
        getModuleFieldBuilder: builder.query({
            query: function (_a) {
                var params = _a.params;
                return ({
                    url: "/moduleBuilder/modulefield",
                    params: params,
                });
            },
        }),
        saveStudioModuleField: builder.mutation({
            query: function (_a) {
                var moduleName = _a.moduleName, body = _a.body;
                return ({
                    url: "/meta/".concat(moduleName, "/field/save"),
                    method: "POST",
                    body: body,
                });
            },
        }),
        deleteStudioModuleField: builder.mutation({
            query: function (_a) {
                var moduleName = _a.moduleName, fieldName = _a.fieldName, body = _a.body;
                return ({
                    url: "/meta/".concat(moduleName, "/field/").concat(fieldName, "/delete"),
                    method: "POST",
                    body: body,
                });
            },
        }),
        getModuleList: builder.query({
            query: function (_a) {
                var table = _a.table, params = _a.params;
                return filterSearchUrl("module/query?table=".concat(table), params);
            },
            providesTags: ["Records", "UserDashlets", "Alerts"],
            transformResponse: function (response) {
                return decodeDeepOptimized(response);
            },
        }),
        getFilters: builder.query({
            query: function (moduleName) { return "/filters/".concat(moduleName); },
        }),
        saveFilter: builder.mutation({
            query: function (_a) {
                var moduleName = _a.moduleName, body = _a.body;
                return ({
                    url: "/filters/".concat(moduleName),
                    method: "POST",
                    body: body,
                });
            },
        }),
        deleteRecords: builder.mutation({
            query: function (_a) {
                var moduleName = _a.moduleName, body = _a.body;
                return ({
                    url: "/remove/record/".concat(moduleName),
                    method: "POST",
                    body: body,
                });
            },
            invalidatesTags: ["Records", "Reminders"],
        }),
        getEmails: builder.query({
            query: function (_a) {
                var recordId = _a.recordId, moduleName = _a.moduleName;
                return "emailAddress?record=".concat(recordId, "&moduleName=").concat(moduleName);
            },
        }),
        getCaseUpdatesById: builder.query({
            query: function (_a) {
                var params = _a.params, id = _a.id;
                return ({
                    url: "/cases/".concat(id, "/updates"),
                    params: params,
                });
            },
        }),
        saveRecord: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/save/record",
                    method: "POST",
                    body: body,
                });
            },
            invalidatesTags: ["Records", "Reminders", "AOR_Reports"],
        }),
        saveAOPCaseUpdates: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/saveAOPCaseUpdates/record",
                    method: "POST",
                    body: body,
                });
            },
        }),
        updateRecords: builder.mutation({
            query: function (_a) {
                var moduleName = _a.moduleName, body = _a.body;
                return ({
                    url: "/update/record/".concat(moduleName),
                    method: "POST",
                    body: body,
                });
            },
            invalidatesTags: ["Records", "Reminders"],
        }),
        uploadTempFile: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/tempUpload",
                    method: "POST",
                    body: body,
                });
            },
        }),
        saveUploadedFile: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/save/fileUploaded",
                    method: "POST",
                    body: body,
                });
            },
        }),
        getFileToDownload: builder.query({
            query: function (_a) {
                var params = _a.params;
                return ({
                    url: "/entryPoint/download",
                    params: params,
                });
            },
        }),
        getOutputImage: builder.query({
            query: function (_a) {
                var params = _a.params;
                return ({
                    url: "/entryPoint/public",
                    params: params,
                });
            },
        }),
        removeFile: builder.mutation({
            query: function (_a) {
                var module = _a.module, id = _a.id, body = _a.body;
                return ({
                    url: "/remove/file/".concat(module, "/").concat(id),
                    method: "POST",
                    body: body,
                });
            },
        }),
        getModuleFieldLayout: builder.query({
            query: function (moduleName) {
                return "/meta/".concat(moduleName, "/layouts/detailviewdefs");
            },
        }),
        getModuleSubpanels: builder.query({
            query: function (moduleName) { return "/meta/".concat(moduleName, "/subpanels"); },
        }),
        getCurrencies: builder.query({
            query: function () { return "/currencies/list"; },
        }),
        getModuleSubpanelData: builder.query({
            query: function (_a) {
                var moduleName = _a.moduleName, recordId = _a.recordId, subpanels = _a.subpanels, _b = _a.limit, limit = _b === void 0 ? -1 : _b, _c = _a.offset, offset = _c === void 0 ? 0 : _c, order = _a.order, sort = _a.sort;
                return ({
                    url: "/subpanels/".concat(moduleName, "/").concat(recordId),
                    params: { subpanels: subpanels, limit: limit, offset: offset, order: order, sort: sort },
                });
            },
            //providesTags: ["Subpanel"],
            providesTags: function (result, error, _a) {
                var subpanels = _a.subpanels;
                return [
                    { type: "Subpanel", id: subpanels },
                ];
            },
        }),
        deleteRelationship: builder.mutation({
            query: function (_a) {
                var module = _a.module, body = _a.body;
                return ({
                    url: "/delete/".concat(module, "/relationship"),
                    method: "POST",
                    body: body,
                });
            },
            //invalidatesTags: ["Subpanel"],
            invalidatesTags: function (result, error, _a) {
                var body = _a.body;
                return [
                    { type: "Subpanel", id: body.subpanelID },
                ];
            },
        }),
        getModuleBuilderPackages: builder.query({
            query: function () { return "/moduleBuilder/packages"; },
        }),
        getModuleBuilderDropdowns: builder.query({
            query: function () { return "/moduleBuilder/dropdowns"; },
        }),
        getModuleBuilderExportCustom: builder.query({
            query: function (_a) {
                var module = _a.module;
                return "/moduleBuilder/exportCustom/".concat(module);
            },
        }),
        saveModuleBuilderExportCustom: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/moduleBuilder/exportCustom",
                    method: "POST",
                    body: body,
                });
            },
        }),
        getImportableModules: builder.query({
            query: function () { return "/admin/importableModules"; },
        }),
        getFacelift: builder.query({
            query: function (_a) {
                var moduleName = _a.moduleName, recordId = _a.recordId;
                return "/facelift/".concat(moduleName, "/").concat(recordId);
            },
        }),
        saveFacelift: builder.mutation({
            query: function (_a) {
                var moduleName = _a.moduleName, recordId = _a.recordId, body = _a.body;
                return ({
                    url: "/facelift/".concat(moduleName, "/").concat(recordId),
                    method: "POST",
                    body: body,
                });
            },
        }),
        getFileImportToDownload: builder.query({
            query: function (_a) {
                var params = _a.params;
                return ({
                    url: "/entryPoint/export",
                    params: params,
                });
            },
        }),
        getModuleStudioLabels: builder.query({
            query: function (_a) {
                var moduleName = _a.moduleName, label = _a.label, lang = _a.lang;
                return "/studio/".concat(moduleName, "/Labels?labels=").concat(label, "&lang=").concat(lang);
            },
        }),
        getModuleStudioSubpanels: builder.query({
            query: function (_a) {
                var moduleName = _a.moduleName, params = _a.params;
                return ({
                    url: "/studio/".concat(moduleName, "/Subpanels"),
                    params: params,
                });
            },
            transformResponse: function (response) {
                return decodeDeepOptimized(response);
            },
        }),
        getModuleStudioSubpanel: builder.query({
            query: function (_a) {
                var moduleName = _a.moduleName, params = _a.params;
                return ({
                    url: "/studio/".concat(moduleName, "/Subpanel"),
                    params: params,
                });
            },
        }),
        saveModuleStudioSubpanel: builder.mutation({
            query: function (_a) {
                var moduleName = _a.moduleName, params = _a.params, body = _a.body;
                return ({
                    url: "/studio/".concat(moduleName, "/Subpanel/save"),
                    method: "POST",
                    params: params,
                    body: body,
                });
            },
        }),
        saveModuleBuilderLayoutListWidget: builder.mutation({
            query: function (_a) {
                var moduleName = _a.moduleName, params = _a.params, body = _a.body;
                return ({
                    url: "/moduleBuilder/".concat(moduleName, "/list/widget/save"),
                    method: "POST",
                    params: params,
                    body: body,
                });
            },
        }),
        getModuleBuilderLayoutListWidgets: builder.query({
            query: function (_a) {
                var moduleName = _a.moduleName, params = _a.params;
                return ({
                    url: "/meta/".concat(moduleName, "/list/widgets"),
                    params: params,
                });
            },
        }),
        getModuleBuilderRelationships: builder.query({
            query: function (_a) {
                var moduleName = _a.moduleName, packageName = _a.packageName, lang = _a.lang;
                return "/moduleBuilder/relationships?package=&module=".concat(moduleName, "&lang=").concat(lang);
            },
        }),
        getModuleBuilderRelationship: builder.query({
            query: function (_a) {
                var moduleName = _a.moduleName, relationship_name = _a.relationship_name, lang = _a.lang;
                return "/moduleBuilder/relationship?package=&module=".concat(moduleName, "&relationship_name=").concat(relationship_name, "&lang=").concat(lang);
            },
        }),
        getModuleBuilderDropdown: builder.query({
            query: function (_a) {
                var dropdown = _a.dropdown, lang = _a.lang;
                return "/moduleBuilder/dropdown?dropdown=".concat(dropdown, "&lang=").concat(lang);
            },
        }),
        getModuleBuilderLayouts: builder.query({
            query: function (_a) {
                var params = _a.params;
                return ({
                    url: "/moduleBuilder/layouts",
                    params: params,
                });
            },
        }),
        getModuleBuilderLayout: builder.query({
            query: function (_a) {
                var moduleName = _a.moduleName, layout = _a.layout, params = _a.params;
                return ({
                    url: "/moduleBuilder/layouts/".concat(moduleName, "/").concat(layout),
                    params: params,
                });
            },
        }),
        getModuleBuilderLabels: builder.query({
            query: function (_a) {
                var params = _a.params;
                return ({
                    url: "/moduleBuilder/labels",
                    params: params,
                });
            },
        }),
        getModuleBuilderGridLayout: builder.query({
            query: function (_a) {
                var moduleName = _a.moduleName, layout = _a.layout, params = _a.params;
                return ({
                    url: "/moduleBuilder/gridLayoutFields/".concat(moduleName, "/").concat(layout),
                    params: params,
                });
            },
        }),
        saveModuleBuilderLayout: builder.mutation({
            query: function (_a) {
                var moduleName = _a.moduleName, layout = _a.layout, body = _a.body;
                return ({
                    url: "/moduleBuilder/saveModuleLayout/".concat(moduleName, "/").concat(layout),
                    method: "POST",
                    body: body,
                });
            },
            invalidatesTags: ["UserDashlets"],
        }),
        saveRelationship: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/moduleBuilder/relationship",
                    method: "POST",
                    body: body,
                });
            },
        }),
        saveStudioLabels: builder.mutation({
            query: function (_a) {
                var moduleName = _a.moduleName, body = _a.body;
                return ({
                    url: "/studio/".concat(moduleName, "/labels/save"),
                    method: "POST",
                    body: body,
                });
            },
        }),
        saveStudioDropdown: builder.mutation({
            query: function (_a) {
                var moduleName = _a.moduleName, viewpackage = _a.viewpackage, body = _a.body;
                return ({
                    url: "/moduleBuilder/dropdown/".concat(moduleName, "/save?view_package=").concat(viewpackage),
                    method: "POST",
                    body: body,
                });
            },
        }),
        getFilePreviewImport: builder.query({
            query: function (_a) {
                var params = _a.params, moduleName = _a.moduleName;
                return ({
                    url: "/admin/filePreview/".concat(moduleName),
                    params: params,
                });
            },
        }),
        getFileMappingImport: builder.query({
            query: function (_a) {
                var params = _a.params, moduleName = _a.moduleName;
                return ({
                    url: "/admin/fileMapping/".concat(moduleName),
                    params: params,
                });
            },
        }),
        getDuplicateCheckImport: builder.query({
            query: function (_a) {
                var params = _a.params, moduleName = _a.moduleName;
                return ({
                    url: "/admin/checkDuplicate/".concat(moduleName),
                    params: params,
                });
            },
        }),
        getExecuteImport: builder.query({
            query: function (_a) {
                var params = _a.params, moduleName = _a.moduleName;
                return ({
                    url: "/admin/importFile/".concat(moduleName),
                    params: params,
                });
            },
        }),
        getLastImport: builder.query({
            query: function (_a) {
                var params = _a.params, moduleName = _a.moduleName;
                return ({
                    url: "/admin/lastImport/".concat(moduleName),
                    params: params,
                });
            },
        }),
        getUndoImport: builder.query({
            query: function (_a) {
                var params = _a.params, module = _a.module;
                return ({
                    url: "/admin/undoimport/".concat(module),
                    params: params,
                });
            },
        }),
        getTempFileImport: builder.query({
            query: function (_a) {
                var params = _a.params, module = _a.module;
                return ({
                    url: "/admin/tempFileImport/".concat(module),
                    params: params,
                });
            },
        }),
        saveLayoutDetail: builder.mutation({
            query: function (_a) {
                var moduleName = _a.moduleName, layoutName = _a.layoutName, body = _a.body;
                return ({
                    url: "moduleBuilder/saveModuleLayout/".concat(moduleName, "/").concat(layoutName),
                    method: "POST",
                    body: body,
                });
            },
        }),
        getModuleRecord: builder.query({
            query: function (_a) {
                var moduleName = _a.moduleName, recordId = _a.recordId;
                return "/load/record/".concat(moduleName, "/").concat(recordId);
            },
            providesTags: ["Records", "Reminders"],
            transformResponse: function (response) {
                return decodeDeepOptimized(response);
            },
        }),
        getLocaleConfig: builder.query({
            query: function (_a) {
                var params = _a.params;
                return ({
                    url: "/admin/locale/config",
                    params: params,
                });
            },
            providesTags: ["Admin"],
        }),
        saveLocaleConfig: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/admin/locale/config",
                    method: "POST",
                    body: body,
                });
            },
            invalidatesTags: ["Admin"],
        }),
        getRepairAndRebuildAdministration: builder.query({
            query: function (_a) {
                var params = _a.params;
                return ({
                    url: "/admin/repairAndRebuild",
                    params: params,
                });
            },
            providesTags: ["Admin"],
        }),
        getConfiguratorConfig: builder.query({
            query: function (_a) {
                var params = _a.params;
                return ({
                    url: "/admin/configurator",
                    params: params,
                });
            },
            providesTags: ["Admin"],
        }),
        saveConfigurator: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/configurator",
                    method: "POST",
                    body: body,
                });
            },
            invalidatesTags: ["Admin"],
        }),
        getPasswordManagerConfig: builder.query({
            query: function (_a) {
                var params = _a.params;
                return ({
                    url: "/admin/passwordManager",
                    params: params,
                });
            },
        }),
        getPasswordManagerRules: builder.query({
            query: function (_a) {
                var params = _a.params;
                return ({
                    url: "/passwordConfig/rules",
                    params: params,
                });
            },
        }),
        savePasswordManagerConfig: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/admin/passwordManager",
                    method: "POST",
                    body: body,
                });
            },
        }),
        generateUserPassword: builder.mutation({
            query: function (_a) {
                var username = _a.username, useremail = _a.useremail, userLang = _a.userLang, link = _a.link, captchaToken = _a.captchaToken;
                return ({
                    url: "/profile/generatePassword",
                    method: "POST",
                    body: __assign(__assign({ username: username, useremail: useremail, language: userLang }, (link ? { link: link } : {})), (captchaToken ? { captchaToken: captchaToken } : {})),
                });
            },
        }),
        resetPassword: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/entryPoint/resetPassword",
                    method: "POST",
                    body: body,
                });
            },
        }),
        getSecurityGroupsConfig: builder.query({
            query: function (_a) {
                var params = _a.params;
                return ({
                    url: "/admin/securityGroups/config",
                    params: params,
                });
            },
            providesTags: ["securityGroups"],
        }),
        getDetailACLRoles: builder.query({
            query: function (_a) {
                var params = _a.params;
                return ({
                    url: "/detail/role",
                    params: params,
                });
            },
        }),
        getLoadRoles: builder.query({
            query: function (_a) {
                var params = _a.params;
                return ({
                    url: "/acl/role",
                    params: params,
                });
            },
        }),
        saveSecurityGroupsConfig: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/admin/securityGroups/config",
                    method: "POST",
                    body: body,
                });
            },
            invalidatesTags: ["securityGroups"],
        }),
        getReminders: builder.query({
            query: function (_a) {
                var moduleName = _a.moduleName, recordId = _a.recordId;
                return "/reminders/".concat(moduleName, "/").concat(recordId);
            },
            providesTags: ["Reminders"],
        }),
        getRemindersInvitees: builder.query({
            query: function (_a) {
                var moduleName = _a.moduleName, recordId = _a.recordId;
                return "/reminders/invitees/".concat(moduleName, "/").concat(recordId);
            },
            providesTags: ["Reminders"],
        }),
        getRemindersAllInvitees: builder.query({
            query: function (_a) {
                var moduleName = _a.moduleName, recordId = _a.recordId;
                return "/reminders/allInvitees/".concat(moduleName, "/").concat(recordId);
            },
            providesTags: ["Reminders"],
        }),
        getAdminThemes: builder.query({
            query: function (_a) {
                var params = _a.params;
                return ({
                    url: "/admin/themes",
                    params: params,
                });
            },
        }),
        saveAdminThemes: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/admin/theme/save",
                    method: "POST",
                    body: body,
                });
            },
        }),
        saveAdminThemesCustomize: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/admin/theme/customize/save",
                    method: "POST",
                    body: body,
                });
            },
        }),
        getAdminColors: builder.query({
            query: function (_a) {
                var params = _a.params;
                return ({
                    url: "/admin/colors",
                    params: params,
                });
            },
        }),
        saveAdminColors: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/admin/color/save",
                    method: "POST",
                    body: body,
                });
            },
        }),
        getOpportunitiesByLeadSourceByOutcomeDashlets: builder.query({
            query: function () { return "/opportunitiesByLeadSourceByOutcomeDashlet"; },
            providesTags: ["UserDashlets"],
        }),
        getOpportunitiesByLeadSourceDashlets: builder.query({
            query: function () { return "/opportunitiesByLeadSourceDashlet"; },
            providesTags: ["UserDashlets"],
        }),
        getOutcomeByMonthDashlet: builder.query({
            query: function () { return "/outcomeByMonthDashlet"; },
            providesTags: ["UserDashlets"],
        }),
        getCampaignROIChartDashlet: builder.query({
            query: function () { return "/campaignROIChartDashlet"; },
            providesTags: ["UserDashlets"],
        }),
        getMyPipelineBySalesStageDashlet: builder.query({
            query: function () { return "/myPipelineBySalesStageDashlet"; },
            providesTags: ["UserDashlets"],
        }),
        getPipelineBySalesStageDashlet: builder.query({
            query: function () { return "/pipelineBySalesStageDashlet"; },
            providesTags: ["UserDashlets"],
        }),
        saveDashletPreferences: builder.mutation({
            query: function (_a) {
                var dashlets = _a.dashlets, isNew = _a.isNew;
                return ({
                    url: "/dashlets",
                    method: "POST",
                    body: { dashlets: dashlets, isNew: isNew },
                });
            },
            invalidatesTags: ["UserDashlets"],
        }),
        searchDashletChart: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/searchDashletChart",
                    method: "POST",
                    body: body,
                });
            },
        }),
        searchBasicModules: builder.query({
            query: function (_a) {
                var params = _a.params;
                return ({
                    url: "/search",
                    params: params,
                });
            },
        }),
        getUserModules: builder.query({
            query: function () { return ({
                url: "/userModules",
            }); },
        }),
        searchAdvancedModules: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/searchAdvanced",
                    method: "POST",
                    body: body,
                });
            },
        }),
        saveSearchHistory: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/saveSearchHistory",
                    method: "POST",
                    body: body,
                });
            },
        }),
        getRelationshipWithContact: builder.query({
            query: function (_a) {
                var module = _a.module, id = _a.id;
                return "/search/relation/".concat(module, "/").concat(id);
            },
        }),
        getSearchHistory: builder.query({
            query: function () { return "/getSearchHistory"; },
            providesTags: ["UserDashlets"],
        }),
        getDashletsPreferencesUser: builder.query({
            query: function () { return "/dashlets"; },
            providesTags: ["UserDashlets"],
        }),
        getAllDashlets: builder.query({
            query: function () { return "/allDashlets"; },
        }),
        getAlerts: builder.query({
            query: function () { return "/etcalerts"; },
            providesTags: ["Alerts"],
        }),
        markAsReadAlert: builder.mutation({
            query: function (_a) {
                var id = _a.id;
                return ({
                    url: "/markAsRead/".concat(id),
                    method: "POST",
                    invalidatesTags: ["Alerts"],
                });
            },
        }),
        getHistory: builder.query({
            query: function (_a) {
                var module = _a.module;
                return "/history/".concat(module, "/recently_viewed");
            },
        }),
        createFavorite: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/favorites/save",
                    method: "POST",
                    body: body,
                    invalidatesTags: ["Favorites"],
                });
            },
        }),
        removeFavorite: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/favorites/remove",
                    method: "POST",
                    body: body,
                    invalidatesTags: ["Favorites"],
                });
            },
        }),
        getFavorites: builder.query({
            query: function (_a) {
                var params = _a.params;
                return ({
                    url: "/favorites",
                    params: params,
                    providesTags: ["Favorites"],
                });
            },
        }),
        checkFavorite: builder.query({
            query: function (_a) {
                var params = _a.params;
                return ({
                    url: "/favorites/check",
                    params: params,
                });
            },
        }),
        getAORDataTree: builder.query({
            query: function (_a) {
                var module = _a.module;
                return "/reports/dataTree/".concat(module);
            },
            providesTags: ["AOR_Reports"],
        }),
        getAORFields: builder.query({
            query: function (_a) {
                var module = _a.module;
                return "/reports/fields/".concat(module);
            },
            providesTags: ["AOR_Reports"],
        }),
        getRelationshipWOpportunities: builder.mutation({
            query: function (_a) {
                var module = _a.module, id = _a.id, body = _a.body;
                var idPart = id ? "/".concat(id) : "";
                var modulePart = module ? "/".concat(module) : "";
                return {
                    url: "relationshipWOpportunities".concat(modulePart).concat(idPart),
                    method: "POST",
                    body: body,
                };
            },
        }),
        getQualifiedLeadsCount: builder.mutation({
            query: function (_a) {
                var module = _a.module, id = _a.id, body = _a.body;
                return {
                    url: "getQualifiedLeadsCount/leads",
                    method: "POST",
                    body: body,
                };
            },
        }),
        getCallCountsByPeriods: builder.mutation({
            query: function (_a) {
                var module = _a.module, body = _a.body;
                var modulePart = module ? "/".concat(module) : "";
                return {
                    url: "getCallCountsByPeriods".concat(modulePart),
                    method: "POST",
                    body: body,
                };
            },
        }),
        getKpiForCases: builder.mutation({
            query: function (_a) {
                var module = _a.module, body = _a.body;
                var modulePart = module ? "/".concat(module) : "";
                return {
                    url: "getKpiForCases".concat(modulePart),
                    method: "POST",
                    body: body,
                };
            },
        }),
        getEmailConfig: builder.query({
            query: function (_a) {
                var params = _a.params;
                return ({
                    url: "/emailman/config",
                    params: params,
                });
            },
        }),
        saveEmailConfig: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/emailman/config",
                    method: "POST",
                    body: body,
                });
            },
        }),
        sendTestEmail: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/emailman/test",
                    method: "POST",
                    body: body,
                });
            },
        }),
        getColorAlgoRatio: builder.query({
            query: function () { return "/getAllColorPaletteAlgoGoldenRatio"; },
        }),
        getAORFieldDefs: builder.query({
            query: function (_a) {
                var report_module = _a.report_module, module = _a.module, fieldname = _a.fieldname;
                return "/reports/fieldDefs/".concat(report_module, "/").concat(module, "/").concat(fieldname);
            },
            providesTags: ["AOR_Reports"],
        }),
        getAORFieldsValues: builder.query({
            query: function (_a) {
                var id = _a.id;
                return "/reports/fields/meta/".concat(id);
            },
            providesTags: ["AOR_Reports"],
        }),
        getAORConditionsOperator: builder.query({
            query: function (_a) {
                var module = _a.module, fieldname = _a.fieldname;
                return "/reports/conditions/operator/".concat(module, "/").concat(fieldname);
            },
        }),
        getAORFieldType: builder.query({
            query: function (_a) {
                var module = _a.module, fieldname = _a.fieldname, params = _a.params;
                return ({
                    url: "/reports/field/type/".concat(module, "/").concat(fieldname),
                });
            },
        }),
        getAORModuleFieldType: builder.query({
            query: function (_a) {
                var module = _a.module, fieldname = _a.fieldname, params = _a.params;
                return ({
                    url: "/reports/fieldType/".concat(module, "/").concat(fieldname),
                    params: params,
                });
            },
        }),
        getAORConditionValues: builder.query({
            query: function (_a) {
                var id = _a.id;
                return "/reports/conditions/meta/".concat(id);
            },
            providesTags: ["AOR_Reports"],
        }),
        getAORChartValues: builder.query({
            query: function (_a) {
                var id = _a.id;
                return "/reports/charts/meta/".concat(id);
            },
            providesTags: ["AOR_Reports"],
        }),
        getReportsList: builder.query({
            query: function (_a) {
                var id = _a.id;
                return "/reports/list/".concat(id);
            },
            providesTags: ["AOR_Reports"],
        }),
        getReportsChartsData: builder.query({
            query: function (_a) {
                var id = _a.id;
                return "/reports/charts/".concat(id);
            },
            providesTags: ["AOR_Reports"],
        }),
        getAdminUpgradeWizard: builder.query({
            query: function () { return "/admin/upgradeWizard"; },
            providesTags: ["UpgradeWizard"],
        }),
        deployedModule: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/moduleDeployed/files",
                    method: "POST",
                    body: body,
                });
            },
            invalidatesTags: ["UpgradeWizard"],
        }),
        removeModule: builder.mutation({
            query: function (_a) {
                var body = _a.body, id = _a.id;
                return ({
                    url: "/admin/upgradeWizard/remove/".concat(id),
                    method: "POST",
                    body: body,
                });
            },
            invalidatesTags: ["UpgradeWizard"],
        }),
        updateModule: builder.mutation({
            query: function (_a) {
                var body = _a.body, method = _a.method, step = _a.step;
                return ({
                    url: "/admin/upgradeWizard/".concat(method, "/").concat(step),
                    method: "POST",
                    body: body,
                });
            },
            invalidatesTags: ["UpgradeWizard"],
        }),
        getInboundEmails: builder.query({
            query: function (_a) {
                var type = _a.type;
                return "/admin/inboundEmail/settings/".concat(type);
            },
        }),
        saveInboundEmailSettings: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/admin/inboundEmailSystemSettings/save",
                    method: "POST",
                    body: body,
                });
            },
        }),
        getEmailTemplatesOptions: builder.query({
            query: function () { return "/emailTemplatesArr"; },
        }),
        testInboundEmailConnection: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/inboundEmail/testConnectionSettings",
                    method: "POST",
                    body: body,
                });
            },
        }),
        getAdminMenu: builder.query({
            query: function () { return "/getAdminMenu"; },
            transformResponse: function (response) {
                return decodeDeepOptimized(response);
            },
        }),
        getCampaignConfig: builder.query({
            query: function (_a) {
                var params = _a.params;
                return ({
                    url: "/emailman/campaign",
                    params: params,
                });
            },
        }),
        saveCampaignConfig: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/emailman/campaign",
                    method: "POST",
                    body: body,
                });
            },
        }),
        chatIA: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/ChatIA",
                    method: "POST",
                    body: body,
                });
            },
        }),
        getModuleRelationNotes: builder.query({
            query: function (moduleName) { return "/moduleRelationNotes/".concat(moduleName); },
            transformResponse: function (response) {
                return decodeDeepOptimized(response);
            },
        }),
        getCustomizeAdminThemes: builder.query({
            query: function () { return "/admin/themes/customize"; },
        }),
        exportConfigTheme: builder.query({
            query: function () { return "/theme/exportConfig"; },
        }),
        saveConnector: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/saveConnector",
                    method: "POST",
                    body: body,
                });
            },
        }),
        getConnectors: builder.query({
            query: function () { return "/connectors"; },
        }),
        deleteConnector: builder.mutation({
            query: function (_a) {
                var id = _a.id;
                return ({
                    url: "/deleteConnector/".concat(id),
                    method: "DELETE",
                });
            },
        }),
        importConfigTheme: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({
                    url: "/theme/importConfig",
                    method: "POST",
                    body: body,
                });
            },
        }),
    }); },
});
export var useGetAccessTokenMutation = apiSlice.useGetAccessTokenMutation, useLoadSystemConfigurationsQuery = apiSlice.useLoadSystemConfigurationsQuery, useGetCurrentUserQuery = apiSlice.useGetCurrentUserQuery, useSaveUserPreferencesMutation = apiSlice.useSaveUserPreferencesMutation, useSaveWidgetPreferencesMutation = apiSlice.useSaveWidgetPreferencesMutation, useGetWidgetsPreferencesUserQuery = apiSlice.useGetWidgetsPreferencesUserQuery, useGetAllMenuQuery = apiSlice.useGetAllMenuQuery, useGetModuleFieldsQuery = apiSlice.useGetModuleFieldsQuery, useGetModuleFieldDefsQuery = apiSlice.useGetModuleFieldDefsQuery, useGetFiltersQuery = apiSlice.useGetFiltersQuery, useGetModuleListQuery = apiSlice.useGetModuleListQuery, useSaveFilterMutation = apiSlice.useSaveFilterMutation, useDeleteRecordsMutation = apiSlice.useDeleteRecordsMutation, useGetEmailsQuery = apiSlice.useGetEmailsQuery, useSaveRecordMutation = apiSlice.useSaveRecordMutation, useUpdateRecordsMutation = apiSlice.useUpdateRecordsMutation, useGetModuleFieldLayoutQuery = apiSlice.useGetModuleFieldLayoutQuery, useGetCurrenciesQuery = apiSlice.useGetCurrenciesQuery, useGetModuleSubpanelsQuery = apiSlice.useGetModuleSubpanelsQuery, useGetModuleSubpanelDataQuery = apiSlice.useGetModuleSubpanelDataQuery, useUploadTempFileMutation = apiSlice.useUploadTempFileMutation, useRemoveFileMutation = apiSlice.useRemoveFileMutation, useDeleteRelationshipMutation = apiSlice.useDeleteRelationshipMutation, useSaveUploadedFileMutation = apiSlice.useSaveUploadedFileMutation, useGetFileToDownloadQuery = apiSlice.useGetFileToDownloadQuery, useLazyGetFileToDownloadQuery = apiSlice.useLazyGetFileToDownloadQuery, useGetModuleBuilderPackagesQuery = apiSlice.useGetModuleBuilderPackagesQuery, useGetModuleBuilderRelationshipsQuery = apiSlice.useGetModuleBuilderRelationshipsQuery, useGetModuleBuilderRelationshipQuery = apiSlice.useGetModuleBuilderRelationshipQuery, useGetModuleBuilderDropdownsQuery = apiSlice.useGetModuleBuilderDropdownsQuery, useGetModuleBuilderLayoutsQuery = apiSlice.useGetModuleBuilderLayoutsQuery, useGetModuleBuilderLayoutQuery = apiSlice.useGetModuleBuilderLayoutQuery, useGetModuleBuilderGridLayoutQuery = apiSlice.useGetModuleBuilderGridLayoutQuery, useGetModuleBuilderLabelsQuery = apiSlice.useGetModuleBuilderLabelsQuery, useLazyGetModuleBuilderLayoutQuery = apiSlice.useLazyGetModuleBuilderLayoutQuery, useGetImportableModulesQuery = apiSlice.useGetImportableModulesQuery, useGetFaceliftQuery = apiSlice.useGetFaceliftQuery, useSaveFaceliftMutation = apiSlice.useSaveFaceliftMutation, useGetFileImportToDownloadQuery = apiSlice.useGetFileImportToDownloadQuery, useGetModuleStudioLabelsQuery = apiSlice.useGetModuleStudioLabelsQuery, useGetModuleStudioSubpanelsQuery = apiSlice.useGetModuleStudioSubpanelsQuery, useGetModuleStudioSubpanelQuery = apiSlice.useGetModuleStudioSubpanelQuery, useSaveModuleStudioSubpanelMutation = apiSlice.useSaveModuleStudioSubpanelMutation, useSaveModuleBuilderLayoutMutation = apiSlice.useSaveModuleBuilderLayoutMutation, useSaveStudioLabelsMutation = apiSlice.useSaveStudioLabelsMutation, useSaveStudioDropdownMutation = apiSlice.useSaveStudioDropdownMutation, useGetModuleFieldTypeQuery = apiSlice.useGetModuleFieldTypeQuery, useGetModuleFieldsBuilderQuery = apiSlice.useGetModuleFieldsBuilderQuery, useGetModuleFieldBuilderQuery = apiSlice.useGetModuleFieldBuilderQuery, useGetFilePreviewImportQuery = apiSlice.useGetFilePreviewImportQuery, useGetFileMappingImportQuery = apiSlice.useGetFileMappingImportQuery, useGetDuplicateCheckImportQuery = apiSlice.useGetDuplicateCheckImportQuery, useGetModuleBuilderDropdownQuery = apiSlice.useGetModuleBuilderDropdownQuery, useSaveStudioModuleFieldMutation = apiSlice.useSaveStudioModuleFieldMutation, useSaveRelationshipMutation = apiSlice.useSaveRelationshipMutation, useDeleteStudioModuleFieldMutation = apiSlice.useDeleteStudioModuleFieldMutation, useGetExecuteImportQuery = apiSlice.useGetExecuteImportQuery, useGetLastImportQuery = apiSlice.useGetLastImportQuery, useGetUndoImportQuery = apiSlice.useGetUndoImportQuery, useGetTempFileImportQuery = apiSlice.useGetTempFileImportQuery, useSaveLayoutDetailMutation = apiSlice.useSaveLayoutDetailMutation, useSaveModuleBuilderLayoutListWidgetMutation = apiSlice.useSaveModuleBuilderLayoutListWidgetMutation, useGetModuleBuilderLayoutListWidgetsQuery = apiSlice.useGetModuleBuilderLayoutListWidgetsQuery, useGetModuleRecordQuery = apiSlice.useGetModuleRecordQuery, useGetLocaleConfigQuery = apiSlice.useGetLocaleConfigQuery, useSaveLocaleConfigMutation = apiSlice.useSaveLocaleConfigMutation, useGetConfiguratorConfigQuery = apiSlice.useGetConfiguratorConfigQuery, useSaveConfiguratorMutation = apiSlice.useSaveConfiguratorMutation, useGetRepairAndRebuildAdministrationQuery = apiSlice.useGetRepairAndRebuildAdministrationQuery, useGetPasswordManagerConfigQuery = apiSlice.useGetPasswordManagerConfigQuery, useSavePasswordManagerConfigMutation = apiSlice.useSavePasswordManagerConfigMutation, useGenerateUserPasswordMutation = apiSlice.useGenerateUserPasswordMutation, useGetSecurityGroupsConfigQuery = apiSlice.useGetSecurityGroupsConfigQuery, useSaveSecurityGroupsConfigMutation = apiSlice.useSaveSecurityGroupsConfigMutation, useGetDetailACLRolesQuery = apiSlice.useGetDetailACLRolesQuery, useGetLoadRolesQuery = apiSlice.useGetLoadRolesQuery, useGetRemindersQuery = apiSlice.useGetRemindersQuery, useGetRemindersInviteesQuery = apiSlice.useGetRemindersInviteesQuery, useGetRemindersAllInviteesQuery = apiSlice.useGetRemindersAllInviteesQuery, useGetAdminThemesQuery = apiSlice.useGetAdminThemesQuery, useSaveAdminThemesMutation = apiSlice.useSaveAdminThemesMutation, useGetAdminColorsQuery = apiSlice.useGetAdminColorsQuery, useSaveAdminColorsMutation = apiSlice.useSaveAdminColorsMutation, useSaveDashletPreferencesMutation = apiSlice.useSaveDashletPreferencesMutation, useGetCampaignROIChartDashletQuery = apiSlice.useGetCampaignROIChartDashletQuery, useGetMyPipelineBySalesStageDashletQuery = apiSlice.useGetMyPipelineBySalesStageDashletQuery, useGetOpportunitiesByLeadSourceByOutcomeDashletsQuery = apiSlice.useGetOpportunitiesByLeadSourceByOutcomeDashletsQuery, useGetOpportunitiesByLeadSourceDashletsQuery = apiSlice.useGetOpportunitiesByLeadSourceDashletsQuery, useGetOutcomeByMonthDashletQuery = apiSlice.useGetOutcomeByMonthDashletQuery, useGetPipelineBySalesStageDashletQuery = apiSlice.useGetPipelineBySalesStageDashletQuery, useGetDashletsPreferencesUserQuery = apiSlice.useGetDashletsPreferencesUserQuery, useSearchBasicModulesQuery = apiSlice.useSearchBasicModulesQuery, useSearchAdvancedModulesMutation = apiSlice.useSearchAdvancedModulesMutation, useGetUserModulesQuery = apiSlice.useGetUserModulesQuery, useGetAllDashletsQuery = apiSlice.useGetAllDashletsQuery, useSearchDashletChartMutation = apiSlice.useSearchDashletChartMutation, useGetAlertsQuery = apiSlice.useGetAlertsQuery, useMarkAsReadAlertMutation = apiSlice.useMarkAsReadAlertMutation, useGetHistoryQuery = apiSlice.useGetHistoryQuery, useCreateFavoriteMutation = apiSlice.useCreateFavoriteMutation, useRemoveFavoriteMutation = apiSlice.useRemoveFavoriteMutation, useGetFavoritesQuery = apiSlice.useGetFavoritesQuery, useCheckFavoriteQuery = apiSlice.useCheckFavoriteQuery, useGetOutputImageQuery = apiSlice.useGetOutputImageQuery, useSaveSearchHistoryMutation = apiSlice.useSaveSearchHistoryMutation, useGetRelationshipWithContactQuery = apiSlice.useGetRelationshipWithContactQuery, useGetQualifiedLeadsCountMutation = apiSlice.useGetQualifiedLeadsCountMutation, useGetCallCountsByPeriodsMutation = apiSlice.useGetCallCountsByPeriodsMutation, useGetKpiForCasesMutation = apiSlice.useGetKpiForCasesMutation, useGetSearchHistoryQuery = apiSlice.useGetSearchHistoryQuery, useGetAORDataTreeQuery = apiSlice.useGetAORDataTreeQuery, useGetAORFieldsQuery = apiSlice.useGetAORFieldsQuery, useGetAORFieldDefsQuery = apiSlice.useGetAORFieldDefsQuery, useGetRelationshipWOpportunitiesMutation = apiSlice.useGetRelationshipWOpportunitiesMutation, useGetAORFieldsValuesQuery = apiSlice.useGetAORFieldsValuesQuery, useGetAORConditionsOperatorQuery = apiSlice.useGetAORConditionsOperatorQuery, useGetAORFieldTypeQuery = apiSlice.useGetAORFieldTypeQuery, useGetAORModuleFieldTypeQuery = apiSlice.useGetAORModuleFieldTypeQuery, useGetAORConditionValuesQuery = apiSlice.useGetAORConditionValuesQuery, useGetColorAlgoRatioQuery = apiSlice.useGetColorAlgoRatioQuery, useGetAORChartValuesQuery = apiSlice.useGetAORChartValuesQuery, useGetReportsListQuery = apiSlice.useGetReportsListQuery, useGetReportsChartsDataQuery = apiSlice.useGetReportsChartsDataQuery, useChangeCurrentLangMutation = apiSlice.useChangeCurrentLangMutation, useSaveAOPCaseUpdatesMutation = apiSlice.useSaveAOPCaseUpdatesMutation, useGetCaseUpdatesByIdQuery = apiSlice.useGetCaseUpdatesByIdQuery, useGetEmailConfigQuery = apiSlice.useGetEmailConfigQuery, useSaveEmailConfigMutation = apiSlice.useSaveEmailConfigMutation, useSendTestEmailMutation = apiSlice.useSendTestEmailMutation, useGetAdminUpgradeWizardQuery = apiSlice.useGetAdminUpgradeWizardQuery, useDeployedModuleMutation = apiSlice.useDeployedModuleMutation, useRemoveModuleMutation = apiSlice.useRemoveModuleMutation, useUpdateModuleMutation = apiSlice.useUpdateModuleMutation, useGetInboundEmailsQuery = apiSlice.useGetInboundEmailsQuery, useSaveInboundEmailSettingsMutation = apiSlice.useSaveInboundEmailSettingsMutation, useGetEmailTemplatesOptionsQuery = apiSlice.useGetEmailTemplatesOptionsQuery, useTestInboundEmailConnectionMutation = apiSlice.useTestInboundEmailConnectionMutation, useGetAdminMenuQuery = apiSlice.useGetAdminMenuQuery, useGetCampaignConfigQuery = apiSlice.useGetCampaignConfigQuery, useSaveCampaignConfigMutation = apiSlice.useSaveCampaignConfigMutation, useGetModuleWizardBuilderQuery = apiSlice.useGetModuleWizardBuilderQuery, useGetCustomizeAdminThemesQuery = apiSlice.useGetCustomizeAdminThemesQuery, useSaveAdminThemesCustomizeMutation = apiSlice.useSaveAdminThemesCustomizeMutation, useGetModuleBuilderExportCustomQuery = apiSlice.useGetModuleBuilderExportCustomQuery, useSaveModuleBuilderExportCustomMutation = apiSlice.useSaveModuleBuilderExportCustomMutation, useGetModuleRelationNotesQuery = apiSlice.useGetModuleRelationNotesQuery, useExportConfigThemeQuery = apiSlice.useExportConfigThemeQuery, useImportConfigThemeMutation = apiSlice.useImportConfigThemeMutation, useChatIAMutation = apiSlice.useChatIAMutation, useSaveConnectorMutation = apiSlice.useSaveConnectorMutation, useGetConnectorsQuery = apiSlice.useGetConnectorsQuery, useDeleteConnectorMutation = apiSlice.useDeleteConnectorMutation, useResetPasswordMutation = apiSlice.useResetPasswordMutation, useGetPasswordManagerRulesQuery = apiSlice.useGetPasswordManagerRulesQuery, useLazyExportConfigThemeQuery = apiSlice.useLazyExportConfigThemeQuery;
